// extracted by mini-css-extract-plugin
export default {"join-chat":"JoinChat_join-chat__Mjf9b","join-chat__name":"JoinChat_join-chat__name__0B-qM","join-chat__purpose":"JoinChat_join-chat__purpose__J7zsy"};